import { useMemo } from "react";
import { useBackwardData } from "~/utils/hooks";
import { utils } from "~/utils";

/**
 * Parses `backward_data` from location state and returns ready-to-use initial
 * values for the SSOT Web Form.
 *
 * @param {Object} location - React Router location object (props.location).
 * @returns {{
 *   initialTableData: Array,
 *   initialValues: Object
 * }}
 */
export default function useSSOTBackwardData(location) {
    const backward_data = useBackwardData(location);

    return useMemo(() => {
        const DATE_FIELDS = ["customer_request_delivery_date", "project_request_delivery_date"];

        const rawTableData = backward_data ? backward_data.data_table || [] : [];
        const initialTableData = rawTableData.map(row => {
            const normalized = { ...row };
            DATE_FIELDS.forEach(field => {
                if (normalized[field]) normalized[field] = utils.strToDate(normalized[field], "DD/MM/YYYY") || normalized[field];
            });
            return normalized;
        });

        const form_data = backward_data ? backward_data.form_data || {} : {};

        const initialActivity =
            backward_data && initialTableData.length > 0
                ? { value: form_data.activity, label: initialTableData[0].activity_name }
                : null;

        const initialCustomerRequestDeliveryDate = form_data.customer_request_delivery_date
            ? new Date(form_data.customer_request_delivery_date)
            : null;

        const initialProjectRequestDeliveryDate = form_data.project_request_delivery_date
            ? new Date(form_data.project_request_delivery_date)
            : null;

        const initialSiteIds = form_data.customer_site_codes
            ? form_data.customer_site_codes.map(code => ({ value: code, label: code }))
            : [];

        return {
            initialTableData,
            initialValues: {
                activity: initialActivity,
                customer_request_delivery_date: initialCustomerRequestDeliveryDate,
                project_request_delivery_date: initialProjectRequestDeliveryDate,
                site_ids: initialSiteIds,
            },
        };
    }, [backward_data]);
}
